import { render, staticRenderFns } from "./viewPortrait.vue?vue&type=template&id=56d97f26&scoped=true"
import script from "./viewPortrait.vue?vue&type=script&lang=js"
export * from "./viewPortrait.vue?vue&type=script&lang=js"
import style0 from "./viewPortrait.vue?vue&type=style&index=0&id=56d97f26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d97f26",
  null
  
)

export default component.exports